import React from 'react';
import { AnimatedSection } from './AnimatedSection';
export function SoutheastAsiaMap() {
  return <AnimatedSection data-id="element-214">
      <div className="flex flex-col items-center" data-id="element-215">
        <div className="w-full max-w-4xl mx-auto" data-id="element-216">
          <img src="https://cdn.magicpatterns.com/uploads/ihD2A91jqySXY96Xwv9HTm/Body.png" alt="Firetree Fund presence across Southeast Asia — Thailand, Cambodia, Malaysia, Singapore, Philippines" className="w-full h-auto" data-id="element-217" />
        </div>
      </div>
    </AnimatedSection>;
}